import { forwardRef } from '@angular/core';
import { Type } from 'class-transformer';
import { BaseModel } from '../../shared/models/base.model';
import { RoleModel } from './role.model';
import { StoresModel, StoreModel } from './store.model';

export class UserModel extends BaseModel {
    email: any;
    confirmEmail?: string;
    name: string;
    password?: string;
    confirmPassword?: string;
    dni?: string;
    lstTenantIds: string[];
    defautlTenantId: string;
    bucEnableCountry: boolean;
    bucEnableChannel: string;

    @Type(forwardRef(() => RoleModel) as any)
    lstRoles: RoleModel[];
    @Type(forwardRef(() => StoresModel) as any)
    lstCountryStores: StoresModel[];

    get stores(): StoreModel[] {
        if (this.lstCountryStores && this.lstCountryStores.length && this.lstCountryStores[0]) {
            return this.lstCountryStores[0].lstStores;
        }

        return [];
    }
}
